import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';

import MetaTags from 'src/components/HeadMeta';
import { IGameDetail } from 'src/interface';
import { fetchAPI } from 'src/utils/fetch-api';

const GameStore = dynamic(() => import('src/containers/Store/GameStore'));

const GameDetailPage = ({ data, slug }: { data: IGameDetail; slug: string }) => {
	const meta = {
		title: data ? `${data?.name} - ${data?.sub_name}` : 'CreoPlay: Play the Best WEB3 Games',
		description:
			data?.description || 'CREOPLAY is a game store platform that supports all blockchain games.',
		url: `/store/${slug}`,
	};

	return (
		<>
			<MetaTags {...meta} />
			<GameStore data={data} />
		</>
	);
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
	const { slug } = context.params as { slug: string };

	// Example: Fetch data using the slug
	const result = await fetchAPI({
		endpoint: `/games/slug/${slug}`,
	});

	const data = result?.data?.data || undefined;

	return {
		props: {
			data,
			slug,
		},
	};
}

// export async function getStaticPaths() {
// let paths: any[] = [];

// const res = await fetchAPI({
// endpoint: '/home/games',
// params: {
// hasStore: 1,
// },
// });

// const gameList: IGame[] = res?.data?.data;
// if (gameList) {
// paths = gameList?.map((g: IGame) => ({
// params: { slug: g.slug },
// }));
// }

// return {
// paths: paths,
// fallback: 'blocking',
// };
// }

// export const getStaticPaths = () => {
// return {
// paths: [],
// fallback: 'blocking',
// };
// };

// export const getStaticProps: GetStaticProps = wrapper.getStaticProps(() => async (context: any) => {
// const queryClient = new QueryClient();

// let notFound = false;

// const { params } = context;
// const { slug } = params;

// let title = '';

// try {
// const data: any = await queryClient.fetchQuery([queryKeyGameDetail, slug], () =>
// fetchAPI({
// endpoint: `/games/slug/${slug}`,
// }),
// );
// if (data?.data?.status !== 200) {
// return {
// notFound: true,
// };
// }
// const dataGameDetail: IGameDetail = data?.data?.data;
// title = dataGameDetail?.name;

// const paramsGL: any = {
// // sortBy: ['newest'],
// page: 1,
// limit: 20,
// };
// await queryClient.prefetchQuery([queryKeyGameStoreItemList, { slug, paramsGL }], () =>
// fetchAPI({
// endpoint: `/game-stores/game/${slug}`,
// params: paramsGL,
// }),
// );

// await queryClient.prefetchQuery(['chains'], () =>
// fetchAPI({
// endpoint: '/master/chains',
// }),
// );
// } catch (err: any) {
// if (err?.status === 400) {
// return {
// notFound: true,
// };
// } else {
// throw err;
// }
// }

// if (notFound) {
// return {
// notFound: true,
// };
// }

// return {
// props: {
// dehydratedState: dehydrate(queryClient),
// pageProps: {
// title: title,
// },
// title: title,
// },
// revalidate: global.REVALIDATE_EXP,
// };
// });

export default GameDetailPage;
